import React from 'react';
import styled from 'styled-components/macro';

const Root = styled.aside`
  .menu-list > li > ul > li {
    margin-bottom: 0.5rem;
  }
`;

export interface EntryListMenuProps {
  children?: any;
}

export function EntryListMenu(props: EntryListMenuProps) {
  return (
    <Root className="menu">
      <ul className="menu-list has-text-weight-bold">
          {props.children}
      </ul>
    </Root>
);
}
